import { render, staticRenderFns } from "./ncDeclaration.vue?vue&type=template&id=9125bb28"
import script from "./ncDeclaration.vue?vue&type=script&lang=js"
export * from "./ncDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports